import CorrelationsTags from './CorrelationsTags';

export default CorrelationsTags;
